import { render, staticRenderFns } from "./PremiumInput.vue?vue&type=template&id=1916e57f&scoped=true"
import script from "./PremiumInput.vue?vue&type=script&lang=js"
export * from "./PremiumInput.vue?vue&type=script&lang=js"
import style0 from "./PremiumInput.vue?vue&type=style&index=0&id=1916e57f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1916e57f",
  null
  
)

export default component.exports